import React from "react";
import HeroSection from "../components/landing/HeroSection";
import FeaturesSection from "../components/landing/FeatureSection";
import ProductsSection from "../components/landing/ProductSection";
import FooterSection from "../components/landing/FooterSection";
import Productspage from "../components/landing/Productspage";
import SEO from "./SEO";

const LandingPage = () => {
  return (
    <div className="h-screen w-full">
      <SEO
        title="Laynered Store - Premium T-Shirts, Graphic Tees & Oversized Shirts"
        description="Discover the best T-shirts at Laynered Store. Shop premium organic cotton t-shirts, heavyweight cotton shirts, oversized t-shirts, and trendy graphic t-shirts. Sustainable, soft, and luxury style."
        keywords="t-shirt, Graphic t-shirt, plain t-shirt, organic cotton t-shirt, heavyweight cotton, pima cotton t-shirt, branded t-shirts, custom t-shirt, personalized t-shirt, layered t-shirt, oversized t-shirt, crop top t-shirt, v-neck t-shirts for women, Funny t-shirt, vintage t-shirt, tie dye t-shirt, best premium organic cotton t-shirts"
      />
      <section id="hero" className="snap-start">
        <HeroSection />
      </section>
      <section id="features" className="snap-start">
        <ProductsSection />
      </section>
      <section id="view" className="snap-start">
        <Productspage />
      </section>
      <section id="products" className="snap-start">
        <FeaturesSection />
      </section>
      <section id="about" className="snap-start">
        <FooterSection />
      </section>

    </div>
  );
};

export default LandingPage;
